export const MOBILE = 'MOBILE'
export const DESKTOP = 'DESKTOP'
